import api from '@/api';
import { saveParamsToQuery } from '@/utils/helpers';

let currentTicketListRequest = null;

const notifications = {
  namespaced: true,

  state() {
    return {
      isLoading: true,
      quantity: 0,
      quantityInterval: null,
      filterParams: {
        objectName: '',
        region: '',
        number: '',
        date: '',
        customerName: '',
      },
      filterParamsHistory: [],
      search: '',
      list: {
        notification: [],
        pageCount: 0,
        page: 0,
      },
      notificationDetail: null,
    };
  },

  mutations: {
    setFilterParams(state, params) {
      state.filterParams = params.result;
    },

    setPage(state, page) {
      state.list.page = page;
    },

    setSelectedFilters(state, params) {
      state.selectedFilters = params;
    },

    setSelectedFiltersHistory(state, params) {
      state.selectedFiltersHistory = params;
    },

    clearSelectedFiltersHistory(state) {
      state.selectedFiltersHistory = {};
    },

    setSearch(state, value) {
      state.search = value;
    },

    setList(state, data) {
      state.list = { ...data.result };
    },

    changeLoading(state, status) {
      state.isLoading = status;
    },

    setNotificationDetail(state, value) {
      state.notificationDetail = value;
    },

    setQuantity(state, value) {
      state.quantity = value;
    },

    setQuantityInterval(state, value) {
      state.quantityInterval = value;
    },
  },

  actions: {
    async fetchQuantity({ state, commit, dispatch }) {
      clearInterval(state.quantityInterval);

      try {
        const res = await api.notification.quantity();
        commit('setQuantity', res?.data?.result ?? 0);

        const interval = setInterval(() => {
          dispatch('fetchQuantity');
        }, 20000);

        commit('setQuantityInterval', interval);
      } catch (e) {
        console.error(e);
      }
    },

    async setSearch({ commit, dispatch }, value) {
      commit('setSearch', value);
      commit('setPage', 1);
      await dispatch('loadList');
    },
    async setPage({ commit, dispatch }, page) {
      commit('setPage', page);
      await dispatch('loadList');
    },
    async loadList({
      state, commit, rootState, rootGetters,
    }) {
      commit('changeLoading', true);

      try {
        if (currentTicketListRequest) {
          return;
        }
        const { isLoggedIn } = rootState.user;
        const role = rootGetters['user/getPriorityRole']();
        if (!role && isLoggedIn) {
          return;
        }

        const params = {
          pageSize: 10,
          page: state.list.page,
        };

        currentTicketListRequest = api.notification[role].list(params);
        const { data } = await currentTicketListRequest;
        saveParamsToQuery({ page: params.page, search: params.search });
        commit('setList', data);
        currentTicketListRequest = null;
      } catch (e) {
        currentTicketListRequest = null;
        console.log(e);
      } finally {
        commit('changeLoading', false);
      }
    },

    async loadNotificationDetail({ commit, rootState, rootGetters }, { id }) {
      if (rootState.notifications.notificationDetail && rootState.notifications.notificationDetail.id === id) {
        return;
      }

      commit('setNotificationDetail', null);
      commit('changeLoading', true);

      try {
        const { isLoggedIn } = rootState.user;
        const role = rootGetters['user/getPriorityRole']();

        if (!role && isLoggedIn) {
          return;
        }
        const { data } = await api.notification[role].detail({ id });
        commit('setNotificationDetail', data.result);
      } catch (e) {
        console.log(e);
        commit('changeLoading', false);
      } finally {
        commit('changeLoading', false);
      }
    },
  },
};

export default notifications;
